import React from 'react';
import { CheckCircle, ArrowRight, Shield, Clock, Users, Star } from 'lucide-react';

const SocialProofBar = () => {
  return (
    <section className="bg-gradient-to-r from-purple-900/20 via-[#0a0a0b] to-purple-900/20 py-4 px-6 border-y border-purple-500/10">
      <div className="max-w-6xl mx-auto flex flex-wrap items-center justify-center gap-6 md:gap-12 text-sm">
        <div className="flex items-center gap-2 text-gray-300">
          <CheckCircle className="w-4 h-4 text-green-400" />
          <span><strong className="text-white">500+</strong> Engineers Placed</span>
        </div>
        <div className="flex items-center gap-2 text-gray-300">
          <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" />
          <span><strong className="text-white">4.9/5</strong> Client Rating</span>
        </div>
        <div className="flex items-center gap-2 text-gray-300">
          <Clock className="w-4 h-4 text-blue-400" />
          <span><strong className="text-white">72hr</strong> Average Match</span>
        </div>
        <div className="flex items-center gap-2 text-gray-300">
          <Shield className="w-4 h-4 text-purple-400" />
          <span><strong className="text-white">100%</strong> Replacement Guarantee</span>
        </div>
      </div>
    </section>
  );
};

export default SocialProofBar;
